import NewHeader from "../components/NewHeader_dev";
import ProductCSS from "./Product_dev.module.css";
import Loader from '../components/Loader'
import React,{useState,useEffect} from 'react'
import Product_dev from "../components/product_dev";
import Footer from "../components/Footer";

function Product() {
  return (
    <div className={ProductCSS.content}>
      <NewHeader />
      <div>
      <Product_dev />
            <br />
            <br />          
            <Footer />          
      </div>
      
    </div>
  );
}
export default Product;
